export class OrderInfo {
  constructor(order) {
    this.id = order.orderKey;
    this.status = order.status;
    this.createdOn = order.createdOn ? new Date(order.createdOn) : null;
    this.modifiedOn = order.modifiedOn ? new Date(order.modifiedOn) : null;
  }
}
